import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-tos',
  templateUrl: './tos.component.html',
  styleUrls: ['./tos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TosComponent {}
